<template>
  <b-row class="mb-1">
    <b-col>
      <b-table
        :items="servicos"
        :fields="colunasVisiveis"
        class="tabela-pacote"
        bordered
        foot-clone
      >
        <template #thead-top>
          <b-tr>
            <b-th
              v-if="proposta.tipoProposta == 'semchecklist'"
              class="selecao-pacote"
            >
              <span class="titulo-pacote">Pacote</span>

              <pacote-servico-select
                v-if="emEdicao"
                v-model="pacote"
                :label="''"
                class="pacote-selecao"
                :filtro-adicional="tipoPacoteServicos"
                @input="carregarServicosPacote"
              />
              <span v-else>{{ pacote ? pacote.nome : '' }}</span>

              <small
                v-if="pacoteNaoSelecionado"
                class="text-danger"
              >Selecione um pacote de serviço</small>
            </b-th>

            <b-th
              v-else
              class="selecao-pacote"
            >
              <div>
                <span class="titulo-pacote">Pacote</span>

                <pacote-servico-select
                  v-model="pacote"
                  :disabled="true"
                  :label="''"
                  class="pacote-selecao"
                  @input="carregarServicosPacote"
                />
              </div>
            </b-th>

            <b-th class="tabela-botao">
              <div class="botao-acao">
                <b-btn
                  v-if="emEdicao"
                  v-b-tooltip.hover
                  variant="none"
                  title="Salvar"
                  class="btn-outline-success btn-none rounded-pill icone-acao mr-50"
                  @click="salvarPacote"
                >
                  <feather-icon icon="CheckIcon" />
                </b-btn>

                <b-btn
                  v-else
                  v-b-tooltip.hover
                  variant="none"
                  title="Editar"
                  class="btn-outline-primary btn-none rounded-pill icone-acao mr-50"
                  @click="alterarPacote"
                >
                  <feather-icon icon="EditIcon" />
                </b-btn>

                <b-btn
                  v-if="proposta.tipoProposta == 'semchecklist'"
                  v-b-tooltip.hover
                  variant="none"
                  title="Remover"
                  class="btn-outline-danger btn-none rounded-pill icone-acao"
                  @click="limparTabela"
                >
                  <feather-icon icon="TrashIcon" />
                </b-btn>
              </div>
            </b-th>
          </b-tr>
        </template>

        <template #cell(incluirNoContrato)="{ item }">
          <b-form-checkbox
            v-if="proposta.tipoProposta === 'constituicao' || proposta.tipoProposta === 'transferencia'"
            v-model="item.incluirNoContrato"
            :disabled="!emEdicao"
          />
        </template>

        <template #foot(incluirNoContrato)="">
          <span />
        </template>

        <template #cell(servicoPacote)="{ item }">
          <span>{{ item.nome }}</span>
        </template>

        <template #cell(valorAuditar)="{ item }">
          <span>{{ item.valorAuditar | converteValor }}</span>
        </template>

        <template #cell(subTotal)="{ item }">
          <span>{{ item.valorAuditar | converteValor }}</span>
        </template>

        <template #foot(servicoPacote)="">
          <span class="sub-total-servico-pacote">SubTotal</span>
        </template>

        <template #foot(valorAuditar)="">
          <span class="valor-total-servico-pacote">{{ valorTotalAuditar | converteValor }}</span>
        </template>

        <template #foot(acrescimoPacote)="">
          <dinheiro-input
            v-if="emEdicao && acresDesc === 'R$'"
            v-model="proposta.propostasPacotes[tabelaIndex].acrescimoPacote"
            :disabled="acrescimoDesabilitado"
            @input="conferirDesconto()"
          />
          <b-input
            v-else-if="emEdicao"
            v-model="proposta.propostasPacotes[tabelaIndex].acrescimoPacote"
            :disabled="acrescimoDesabilitado"
            @blur="formataPorcentagemAcrescimo"
            @input="conferirDesconto()"
          />
          <span
            v-else-if="!emEdicao"
            class="valor-total-servico-pacote"
          >{{ pacote.acrescimoPacote | converteValor }}</span>
        </template>

        <template #foot(descontoPacote)="">
          <dinheiro-input
            v-if="emEdicao && acresDesc === 'R$'"
            ref="descontoInput"
            v-model="proposta.propostasPacotes[tabelaIndex].descontoPacote"
            :disabled="descontoDesabilitado"
            @input="valorComAcrescimo()"
          />
          <b-input
            v-else-if="emEdicao"
            v-model="proposta.propostasPacotes[tabelaIndex].descontoPacote"
            :disabled="descontoDesabilitado"
            :state="erroPorcentagem ? false : null"
            @blur="formataPorcentagemDesconto"
            @input="valorComAcrescimo()"
          />
          <span
            v-else-if="!emEdicao"
            class="valor-total-servico-pacote"
          >{{ pacote.descontoPacote | converteValor }}</span>
        </template>

        <template #foot(subTotal)="">
          <span
            class="valor-total-servico-pacote"
            style="max-width: 300px; word-break: break-all;"
            :style="valorSubtotal <= 0 && proposta.propostasPacotes[0].servicos ? 'color: red' : ''"
          >{{ valorSubtotal | converteValor }} </span>
        </template>

        <template #table-caption>
          <span>{{ proposta.propostasPacotes[tabelaIndex].observacao || '' }}</span>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.tabela-pacote {
  background-color: var(--table-bg) !important;

  .form-control {
    padding: 0.438rem 0.7rem;
    height: 2.5rem;
  }

  th {
    background-color: var(--table-bg) !important;
  }

  th,
  td {
    padding: 0.5rem 0.2rem;
  }

  .table-hover {
    tr {
      cursor: default !important;
    }
  }

  .botao-acao {
    padding-left: 0.5rem !important;
    padding-top: 0.2rem !important;
  }
}

.valor-total-servico-pacote {
  font-size: 13.2px;
  color: var(--text-primary) !important;
}

.selecao-pacote {
  padding: 0.95rem 0.2rem !important;

  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.titulo-pacote {
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1;
}

.pacote-selecao {
  background-color: var(--card-bg);
  border-radius: 0.357rem;
}

.cor-fundo {
  background-color: var(--card-bg) !important;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import apiParametrizacao from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoGeral/services/api'
import { verificaAcrescimo, valorParaComparar, verificaDesconto } from '@/app-modulo/comercial/cadastro-proposta/shared/services/validationServicos'

export default {
  name: 'TabelaPacoteServico',
  components: {
    PacoteServicoSelect: () => import('@/shared/components/pacote-servico-select/PacoteServicoSelect.vue'),
    DinheiroInput: () => import('@/shared/components/dinheiro-input/DinheiroInput.vue'),
  },
  props: {
    tipoAcresDesc: {
      type: String,
      default: 'R$',
    },
    value: {
      type: Object,
      default: () => {},
    },
    tabelaIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      colunasInner: [
        {
          key: 'incluirNoContrato',
          label: 'Incluir no Contrato',
          thStyle: 'width: 120px;background-color: var(--card-bg) !important;padding: 0.5rem 0.2rem;text-align: center;',
          tdClass: 'cor-fundo text-center',
        },
        {
          key: 'servicoPacote',
          label: 'Serviços',
          thStyle: 'width: 300px;background-color: var(--card-bg) !important;padding: 0.5rem 0.2rem;',
          tdClass: 'cor-fundo',
        },
        {
          key: 'valorAuditar',
          label: 'Valor',
          thStyle: 'width: 149px; background-color: var(--card-bg) !important;padding: 0.5rem 0.2rem;',
          tdClass: 'cor-fundo',
        },
        {
          key: 'acrescimoPacote',
          label: 'Acréscimo',
          thStyle: 'width: 120px; background-color: var(--card-bg) !important;padding: 0.5rem 0.2rem;',
          tdClass: 'cor-fundo',
        },
        {
          key: 'descontoPacote',
          label: 'Desconto',
          thStyle: 'width: 120px; background-color: var(--card-bg) !important;padding: 0.5rem 0.2rem;',
          tdClass: 'cor-fundo',
        },
        {
          key: 'subTotal',
          label: 'Subtotal',
          thStyle: 'width: 169px; background-color: var(--card-bg) !important;padding: 0.5rem 0.2rem;',
          tdClass: 'cor-fundo',
        },
      ],
      pacote: null,
      servicos: [],
      acresDesc: 'R$',
      acrescimoDesabilitado: true,
      descontoDesabilitado: true,
      pacoteNaoSelecionado: false,
      proposta: null,
      emEdicao: true,
      erroPorcentagem: false,
      percentualPacoteNivel2: 20,
      percentualPacoteNivel3: 15,
    }
  },
  computed: {
    ...mapGetters('proposta', ['getCheckOsConstituicao']),
    colunasVisiveis() {
      // Mostra coluna de checkbox apenas para constituição e transferência
      const mostrarCheckbox = this.proposta.tipoProposta === 'constituicao' || this.proposta.tipoProposta === 'transferencia'

      if (mostrarCheckbox) {
        return this.colunasInner
      }

      // Remove a coluna incluirNoContrato para outros tipos
      return this.colunasInner.filter(col => col.key !== 'incluirNoContrato')
    },
    valorTotalAuditar() {
      if (this.pacote && this.pacote.id > 0) {
        return this.pacote.valorPacote
      }
      return 0
    },
    valorSubtotal() {
      let subtotal = 0
      if (this.pacote && this.pacote.id > 0) {
        subtotal = this.pacote.valorPacote
        if (this.acresDesc === '%') {
          if (typeof this.proposta.propostasPacotes[this.tabelaIndex].acrescimoPacote === 'string') {
            subtotal += ((parseFloat(this.proposta.propostasPacotes[this.tabelaIndex].acrescimoPacote.replace('%', ''), 10) / 100) * subtotal)
          }
          if (typeof this.proposta.propostasPacotes[this.tabelaIndex].descontoPacote === 'string') {
            subtotal -= ((parseFloat(this.proposta.propostasPacotes[this.tabelaIndex].descontoPacote.replace('%', ''), 10) / 100) * subtotal)
          }
        } else {
          subtotal += this.proposta.propostasPacotes[this.tabelaIndex].acrescimoPacote || 0
          subtotal -= this.proposta.propostasPacotes[this.tabelaIndex].descontoPacote || 0
        }
        this.subTotalFinal(subtotal)
        if (this.tabelaIndex < 2 && this.proposta.tipoProposta !== 'semchecklist') {
          this.atualizarOutrosPacotes(subtotal)
        }
      }
      return subtotal
    },
  },
  watch: {
    tipoAcresDesc(value, oldValue) {
      if (value && value !== oldValue) {
        this.acresDesc = value
        this.converteValores()
      }
    },
    value(value, oldValue) {
      if (value && value !== oldValue) {
        this.proposta = value
        if (this.proposta.propostasPacotes[this.tabelaIndex]) {
          this.emEdicao = false
          this.pacote = this.proposta.propostasPacotes[this.tabelaIndex]
          this.carregarServicosPacote(this.pacote)
        }
        this.converteValores()
      }
    },
  },
  created() {
    if (!this.value.propostasPacotes) {
      this.value.propostasPacotes = []
      this.value.propostasPacotes[this.tabelaIndex] = { acrescimoPacote: 0, descontoPacote: 0 }
    }
    this.pacote = this.value.propostasPacotes[this.tabelaIndex]
    this.proposta = this.value
    if (this.pacote.servicos) {
      this.carregarServicosPacote(this.pacote)
    }

    if (this.tipoAcresDesc === '%') {
      this.acresDesc = this.tipoAcresDesc
      this.converteValores()
    }
    this.carregarPercentuaisPacote()
  },
  methods: {
    ...mapActions('proposta', ['setCheckOsConstituicao']),
    carregarPercentuaisPacote() {
      apiParametrizacao.getParemtrizacaoGeral()
        .then(payload => {
          if (payload.data) {
            const { percentualPacoteNivel2, percentualPacoteNivel3 } = payload.data

            this.percentualPacoteNivel2 = (typeof percentualPacoteNivel2 === 'number' && !Number.isNaN(percentualPacoteNivel2)) ? percentualPacoteNivel2 : 20
            this.percentualPacoteNivel3 = (typeof percentualPacoteNivel3 === 'number' && !Number.isNaN(percentualPacoteNivel3)) ? percentualPacoteNivel3 : 15
          }
        })
        .catch(() => {
          this.percentualPacoteNivel2 = 20
          this.percentualPacoteNivel3 = 15
        })
    },
    atualizarOutrosPacotes(valorBasePacote1) {
      if (this.tabelaIndex !== 0) {
        return
      }

      if (!this.proposta || !this.proposta.propostasPacotes) {
        return
      }

      const base = valorBasePacote1 || 0

      if (this.proposta.propostasPacotes[1]) {
        const aumento2 = this.percentualPacoteNivel2 || 0
        const valor2 = base + ((base * aumento2) / 100)

        this.$set(this.proposta.propostasPacotes[1], 'valorPacote', valor2)

        if (this.proposta.propostasPacotes[1].servicos && this.proposta.propostasPacotes[1].servicos[0]) {
          this.$set(this.proposta.propostasPacotes[1].servicos[0], 'valorAuditar', valor2)
        }
      }

      if (this.proposta.propostasPacotes[2]) {
        const aumento3 = this.percentualPacoteNivel3 || 0
        const valor3 = base + ((base * aumento3) / 100)

        this.$set(this.proposta.propostasPacotes[2], 'valorPacote', valor3)

        if (this.proposta.propostasPacotes[2].servicos && this.proposta.propostasPacotes[2].servicos[0]) {
          this.$set(this.proposta.propostasPacotes[2].servicos[0], 'valorAuditar', valor3)
        }
      }
    },
    subTotalFinal() {
      if (this.proposta.propostasPacotes[0] && this.proposta.propostasPacotes[0].id > 0 && this.tabelaIndex === 0) {
        let subtotal = 0
        subtotal += this.proposta.propostasPacotes[0].valorPacote
        if (this.acresDesc === '%') {
          if (typeof this.proposta.propostasPacotes[0].acrescimoPacote === 'string') {
            subtotal += ((parseFloat(this.proposta.propostasPacotes[0].acrescimoPacote.replace('%', ''), 10) / 100) * subtotal)
          }
          if (typeof this.proposta.propostasPacotes[0].descontoPacote === 'string') {
            subtotal -= ((parseFloat(this.proposta.propostasPacotes[0].descontoPacote.replace('%', ''), 10) / 100) * subtotal)
          }
        } else {
          subtotal += this.proposta.propostasPacotes[0].acrescimoPacote || 0
          subtotal -= this.proposta.propostasPacotes[0].descontoPacote || 0
        }
        this.$emit('subtotal-pacote', { subTotal: subtotal, subTotalRCC: this.pacote.valorRCC, tipo: 'pacote' })
      }
    },
    conferirDesconto() {
      let number = 0
      if (this.pacote) {
        number = verificaAcrescimo(this.proposta.propostasPacotes[this.tabelaIndex].acrescimoPacote, this.tipoAcresDesc)

        let valorComparar = 0
        valorComparar = valorParaComparar(this.pacote.valorPacote, number, this.tipoAcresDesc)

        if (this.proposta.propostasPacotes[this.tabelaIndex].descontoPacote) {
          let desc = 0
          desc = verificaDesconto(this.proposta.propostasPacotes[this.tabelaIndex].descontoPacote, valorComparar, this.tipoAcresDesc)

          this.descontoValido(desc, valorComparar)
        } else if (this.tipoAcresDesc === 'R$') {
          if (this.$refs.descontoInput) {
            this.$refs.descontoInput.erro = false
          }
        } else {
          this.erroPorcentagem = false
        }
      } else if (this.tipoAcresDesc === 'R$') {
        if (this.$refs.descontoInput) {
          this.$refs.descontoInput.erro = false
        }
      } else {
        this.erroPorcentagem = false
      }
    },
    valorComAcrescimo() {
      let number = 0
      if (this.pacote) {
        number = verificaAcrescimo(this.proposta.propostasPacotes[this.tabelaIndex].acrescimoPacote, this.tipoAcresDesc)

        let valorComparar = 0
        valorComparar = valorParaComparar(this.pacote.valorPacote, number, this.tipoAcresDesc)

        let desc = 0
        if (this.proposta.propostasPacotes[this.tabelaIndex].descontoPacote) {
          this.proposta.propostasPacotes[this.tabelaIndex].validaDescontoPacote = true
          desc = verificaDesconto(this.proposta.propostasPacotes[this.tabelaIndex].descontoPacote, valorComparar, this.tipoAcresDesc)

          this.descontoValido(desc, valorComparar)
        } else {
          this.proposta.validaDescontoPacote = false
          if (this.tipoAcresDesc === 'R$') {
            if (this.$refs.descontoInput) {
              this.$refs.descontoInput.erro = false
            }
          } else {
            this.erroPorcentagem = false
          }
        }
      } else if (this.tipoAcresDesc === 'R$') {
        if (this.$refs.descontoInput) {
          this.$refs.descontoInput.erro = false
        }
      } else {
        this.erroPorcentagem = false
      }
    },
    descontoValido(desc, valorComparar) {
      if (desc > valorComparar) {
        if (this.tipoAcresDesc === 'R$') {
          this.$refs.descontoInput.erro = true
        } else {
          this.erroPorcentagem = true
        }
      } else if (this.tipoAcresDesc === 'R$') {
        if (this.$refs.descontoInput) {
          this.$refs.descontoInput.erro = false
        }
      } else {
        this.erroPorcentagem = false
      }
    },
    carregarServicosPacote(pacoteSelecionado) {
      this.$emit('update-os-constituicao', pacoteSelecionado)
      this.$emit('pacote-selecionado', pacoteSelecionado)
      if (pacoteSelecionado) {
        this.acrescimoDesabilitado = false
        this.descontoDesabilitado = false
      }
      if (this.proposta.propostasPacotes[this.tabelaIndex]) {
        this.proposta.propostasPacotes[this.tabelaIndex] = pacoteSelecionado
      }
      this.servicos = []
      this.servicos = pacoteSelecionado.servicos || null

      // Inicializa incluirNoContrato baseado na periodicidade do serviço
      if (this.servicos && (this.proposta.tipoProposta === 'constituicao' || this.proposta.tipoProposta === 'transferencia')) {
        this.servicos.forEach(servico => {
          if (servico.incluirNoContrato === undefined) {
            // Recorrentes (periodicidade = 1) incluídos por padrão, Eventuais (periodicidade = 2) não incluídos
            this.$set(servico, 'incluirNoContrato', servico.servico?.periodicidade === 1)
          }
        })
      }
    },
    converteValores() {
      this.removeCaracteresValores()
      if (this.acresDesc === '%') {
        this.formataPorcentagemAcrescimo()
        this.formataPorcentagemDesconto()
      }
    },
    removeCaracteresValores() {
      this.proposta.propostasPacotes[this.tabelaIndex].acrescimoPacote = parseFloat(this.proposta.propostasPacotes[this.tabelaIndex].acrescimoPacote, 10)
      this.proposta.propostasPacotes[this.tabelaIndex].descontoPacote = parseFloat(this.proposta.propostasPacotes[this.tabelaIndex].descontoPacote, 10)
    },
    formataPorcentagemAcrescimo() {
      const acrescimoFormatado = parseFloat(this.proposta.propostasPacotes[this.tabelaIndex].acrescimoPacote, 10)
      this.proposta.propostasPacotes[this.tabelaIndex].acrescimoPacote = !acrescimoFormatado ? `${0}%` : `${acrescimoFormatado}%`
    },
    formataPorcentagemDesconto() {
      const descontoFormatado = parseFloat(this.proposta.propostasPacotes[this.tabelaIndex].descontoPacote, 10)
      this.proposta.propostasPacotes[this.tabelaIndex].descontoPacote = !descontoFormatado ? `${0}%` : `${descontoFormatado}%`
    },
    salvarPacote() {
      if (this.pacote && this.pacote.id > 0) {
        this.emEdicao = false
        this.pacoteNaoSelecionado = false
      } else {
        this.pacoteNaoSelecionado = true
      }
    },
    alterarPacote() {
      this.emEdicao = true
      this.acrescimoDesabilitado = false
      this.descontoDesabilitado = false
    },
    limparTabela() {
      this.$emit('subtotal-remove', { subTotal: this.valorSubtotal, subTotalRCC: this.pacote.valorRCC, tipo: 'pacote' })
      this.servicos = []
      this.pacote = null
      this.acrescimoDesabilitado = true
      this.descontoDesabilitado = true
      this.emEdicao = true
      if (this.proposta.propostasPacotes[this.tabelaIndex]) {
        this.proposta.propostasPacotes[this.tabelaIndex] = {}
      }
      this.$emit('update-os-constituicao', this.pacote)
    },
    tipoPacoteServicos(pacotes) {
      const pacotesNaoHonorarios = pacotes.filter(fil => fil.tipo === 'servicos')
      return pacotesNaoHonorarios
    },
  },
}
</script>
